import type { ConditionReport } from './types';

/** True when renter can cancel a confirmed order: on or before 7 calendar days before rental start (UTC). */
export function canRenterCancelConfirmed(rentalStartIso: string, now: Date = new Date()): boolean {
  const start = new Date(rentalStartIso);
  const todayUtc = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const lastCancelDay = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate()));
  lastCancelDay.setUTCDate(lastCancelDay.getUTCDate() - 7);
  const lastCancelUtc = Date.UTC(lastCancelDay.getUTCFullYear(), lastCancelDay.getUTCMonth(), lastCancelDay.getUTCDate());
  return todayUtc <= lastCancelUtc;
}

/** True once the lender has submitted or confirmed the pickup condition report. */
export function isOwnerPickupHandoverComplete(reports: ConditionReport[]): boolean {
  return reports.some(r =>
    r.side === 0
    && !r.superseded
    && (r.draftedByRole === 'lender' || r.confirmedByRole === 'lender'),
  );
}
